import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";
import { getOffsetFromParams, getLimitFromParams } from "./utils";
import _ from "lodash";
import unionDataProvider from "./unionDataProvider";

class SeasonTeamsDataProvider extends BaseDataProvider {
  async getOne(resource, params) {
    console.log(
      "SeasonTeamsDataProvider.getOne(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const GET = gql`
          query {
            SeasonTeamByID(id:"${params.id}") {
              id
              seasonCode
              sportCode
              isInArea 
              rollupMode
              coachEmail
              coachName
              coachUpdated
              team {
                id
                name
                school {
                  name
                }
              }              
              district {
                id
                label
              }
              players {
                id
                person {
                  name
                  lastName
                }
                football {
                  id
                  passingCompletions
                  passingAttempts
                  passingYards
                  passingTouchdowns
                  passingInterceptions
                  passingCompletionPercentage
                  rushingAttempts
                  rushingYards
                  rushingTouchdowns
                  rushingAverage
                  receptions
                  receivingYards
                  receivingTouchdowns
                  receivingAverage
                  totalPoints
                }
                girlsvolleyball {
                  id
                  playerGameCount
                  kills
                  aces
                  digs
                  blocks
                  assists
                  killsPerGame
                  acesPerGame
                  digsPerGame
                  blocksPerGame
                  assistsPerGame
                }
                basketball {
                  id
                  playerGameCount
                  totalPoints
                  pointsAgainst
                  rebounds
                  assists
                  threePointFieldGoals
                  pointsPerGame
                  pointsAgainstPerGame
                  reboundsPerGame 
                  assistsPerGame
                  threePointFieldGoalsPerGame
                }
                soccer {
                  id
                  playerGameCount
                  totalGoals
                  assists
                  shutouts
                }
                baseball {
                  id
                  playerGameCount
                  hits
                  atBats
                  runs
                  doubles
                  triples
                  homeRuns
                  runsBattedIn
                  stolenBases
                  battingAverage
                  inningsPitched
                  runsAllowed
                  earnedRuns
                  hitsAllowed
                  basesOnBalls
                  strikeouts
                  pitchingWins
                  pitchingLosses
                  saves
                  earnedRunAverage
                }
              }
              football {
                id
                seasonWins
                seasonLosses
                seasonTies
                seasonPercentWins
                districtWins
                districtLosses
                districtTies
                districtPercentWins
                homeWins
                homeLosses
                homeTies
                roadWins
                roadLosses
                roadTies
                streak
                differential

                pointsFor
                pointsForPerGame
                totalYards
                totalYardsPerGame
                rushingYards
                rushingYardsPerGame
                passingYards
                passingYardsPerGame

                pointsAgainst
                pointsAgainstPerGame
                totalYardsAllowed
                totalYardsAllowedPerGame
                rushingYardsAllowed
                rushingYardsAllowedPerGame
                passingYardsAllowed
                passingYardsAllowedPerGame
              }
              girlsvolleyball {
                id
                seasonWins
                seasonLosses
                seasonTies
                seasonPercentWins
                districtWins
                districtLosses
                districtTies
                districtPercentWins
                homeWins
                homeLosses
                homeTies
                roadWins
                roadLosses
                roadTies
                streak
                differential
              }
              basketball {
                id
                seasonWins
                seasonLosses
                seasonTies
                seasonPercentWins
                districtWins
                districtLosses
                districtTies
                districtPercentWins
                homeWins
                homeLosses
                homeTies
                roadWins
                roadLosses
                roadTies
                streak
                differential

                teamGameCount
                totalPoints
                pointsPerGame
                pointsAgainst
                pointsAgainstPerGame
                rebounds
                reboundsPerGame
                threePointFieldGoals
                threePointFieldGoalsPerGame
              }
              soccer {
                id
                seasonWins
                seasonLosses
                seasonTies
                seasonPercentWins
                districtWins
                districtLosses
                districtTies
                districtPercentWins
                homeWins
                homeLosses
                homeTies
                roadWins
                roadLosses
                roadTies
                streak
                differential

                teamGameCount
                totalPoints
                totalGoals
                goalsAgainst
                goalsPerGame
                goalsAgainstPerGame
              }
              baseball {
                id
                seasonWins
                seasonLosses
                seasonTies
                seasonPercentWins
                districtWins
                districtLosses
                districtTies
                districtPercentWins
                homeWins
                homeLosses
                homeTies
                roadWins
                roadLosses
                roadTies
                streak
                differential

                teamGameCount
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      return { data: response.data.SeasonTeamByID };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getList(resource, params) {
    const offset = getOffsetFromParams(params);
    const limit = getLimitFromParams(params);
    const name = _.get(params, "filter.name", "");
    const sportCode = _.get(params, "filter.sportCode", "");
    const seasonCode = _.get(params, "filter.seasonCode", "");
    const paramsString = `
        name:"${name === "%%" ? "" : name}"
        offset:${offset}
        limit:${limit}
        ${sportCode ? `sportCode: "${sportCode}"` : ""}
        ${seasonCode ? `seasonCode: "${seasonCode}"` : ""}
      `;

    const GET = gql`
        query {
          data: SeasonTeamsSearch(
            ${paramsString}
          ) {
            total
            data {
              id
              sportCode
              seasonCode
              coachEmail
              coachName
              coachUpdated
              team {
                name
                school {
                  id
                  name
                }
              }
              district {
                id
                label
              }
              isInArea
            }
          }
        }
      `;

    try {
      const response = await this.client.query({ query: GET });
      return response.data.data;
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getManyReference(resource, params) {
    console.log(
      "SeasonTeamsDataProvider.getManyReference(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const GET = gql`
          query {
            TeamByID(id:"${params.id}") {
              id
              seasons {
                id
                seasonCode
                sportCode
                isInArea
                rollupMode
                coachEmail
                coachName
                coachUpdated
                team {
                  id
                }              
                district {
                  id
                  label
                }
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      const data = response.data.TeamByID.seasons;
      return { data: data };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async rollup(resource, params) {
    console.log(
      "SeasonTeamsDataProvider.rollup(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const MUTATION = gql`
          mutation {
            RollupSeasonTeam(id:"${params.id}") {
              id
            }
          }`;
    try {
      const response = await this.client.mutate({ mutation: MUTATION });
      console.log(JSON.stringify(response, null, 2));
      return { data: response.data.RollupSeasonTeam };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async rollupPlayers(resource, params) {
    console.log(
      "SeasonTeamsDataProvider.rollup(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const MUTATION = gql`
          mutation {
            RollupSeasonTeamPlayers(id:"${params.id}")
          }`;
    try {
      const response = await this.client.mutate({ mutation: MUTATION });
      console.log(JSON.stringify(response, null, 2));
      return { data: response.data.RollupSeasonTeamPlayers };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async update(resource, params) {
    console.log(
      "SeasonTeamsDataProvider.update(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    const modifiedPlayerData = _.cloneDeep(objectInfo.modifiedPlayerData);

    if (objectInfo.district) objectInfo.district = objectInfo.district.id;
    delete objectInfo.__typename;
    delete objectInfo.sportCode;
    delete objectInfo.seasonCode;
    delete objectInfo.team;
    if (objectInfo.football) {
      delete objectInfo.football.id;
      delete objectInfo.football.__typename;
    }
    if (objectInfo.girlsvolleyball) {
      delete objectInfo.girlsvolleyball.id;
      delete objectInfo.girlsvolleyball.__typename;
    }
    if (objectInfo.basketball) {
      delete objectInfo.basketball.id;
      delete objectInfo.basketball.__typename;
    }
    if (objectInfo.soccer) {
      delete objectInfo.soccer.id;
      delete objectInfo.soccer.__typename;
    }
    if (objectInfo.baseball) {
      delete objectInfo.baseball.id;
      delete objectInfo.baseball.__typename;
    }
    if (objectInfo.players) {
      delete objectInfo.players;
    }
    if (objectInfo.modifiedPlayerData) {
      delete objectInfo.modifiedPlayerData;
    }

    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    objectString = objectString.replace(
      /rollupMode:"([^"]*)"/,
      "rollupMode:$1"
    );

    const MUTATION = gql`
          mutation {
            UpdateSeasonTeam(${objectString}) {
              id
              seasonCode
              sportCode
              isInArea 
              rollupMode
              coachEmail
              coachName
              coachUpdated
              team {
                id
              }
              district {
                id
                label
              }
              players {
                id
                person {
                  name
                  lastName
                }
                football {
                  id
                  passingCompletions
                  passingAttempts
                  passingYards
                  passingTouchdowns
                  passingInterceptions
                  passingCompletionPercentage
                  rushingAttempts
                  rushingYards
                  rushingTouchdowns
                  rushingAverage
                  receptions
                  receivingYards
                  receivingTouchdowns
                  receivingAverage
                  totalPoints
                }
                girlsvolleyball {
                  id
                  playerGameCount
                  kills
                  aces
                  digs
                  blocks
                  assists
                  killsPerGame
                  acesPerGame
                  digsPerGame
                  blocksPerGame
                  assistsPerGame
                }
                basketball {
                  id
                  playerGameCount
                  totalPoints
                  pointsAgainst
                  rebounds
                  assists
                  threePointFieldGoals
                  pointsPerGame
                  pointsAgainstPerGame
                  reboundsPerGame 
                  assistsPerGame
                  threePointFieldGoalsPerGame
                }
                soccer {
                  id
                  playerGameCount
                  totalGoals
                  assists
                  shutouts
                }
                baseball {
                  id
                  playerGameCount
                  hits
                  atBats
                  runs
                  doubles
                  triples
                  homeRuns
                  runsBattedIn
                  stolenBases
                  battingAverage
                  inningsPitched
                  runsAllowed
                  earnedRuns
                  hitsAllowed
                  basesOnBalls
                  strikeouts
                  pitchingWins
                  pitchingLosses
                  saves
                  earnedRunAverage
                }
              }
              football {
                id
                seasonWins
                seasonLosses
                seasonTies
                seasonPercentWins
                districtWins
                districtLosses
                districtTies
                districtPercentWins
                homeWins
                homeLosses
                homeTies
                roadWins
                roadLosses
                roadTies
                streak
                differential

                pointsFor
                pointsForPerGame
                totalYards
                totalYardsPerGame
                rushingYards
                rushingYardsPerGame
                passingYards
                passingYardsPerGame

                pointsAgainst
                pointsAgainstPerGame
                totalYardsAllowed
                totalYardsAllowedPerGame
                rushingYardsAllowed
                rushingYardsAllowedPerGame
                passingYardsAllowed
                passingYardsAllowedPerGame
              }
              girlsvolleyball {
                id
                seasonWins
                seasonLosses
                seasonTies
                seasonPercentWins
                districtWins
                districtLosses
                districtTies
                districtPercentWins
                homeWins
                homeLosses
                homeTies
                roadWins
                roadLosses
                roadTies
                streak
                differential
              }
              basketball {
                id
                seasonWins
                seasonLosses
                seasonTies
                seasonPercentWins
                districtWins
                districtLosses
                districtTies
                districtPercentWins
                homeWins
                homeLosses
                homeTies
                roadWins
                roadLosses
                roadTies
                streak
                differential

                teamGameCount
                totalPoints
                pointsPerGame
                pointsAgainst
                pointsAgainstPerGame
                rebounds
                reboundsPerGame
                threePointFieldGoals
                threePointFieldGoalsPerGame
              }
              soccer {
                id
                seasonWins
                seasonLosses
                seasonTies
                seasonPercentWins
                districtWins
                districtLosses
                districtTies
                districtPercentWins
                homeWins
                homeLosses
                homeTies
                roadWins
                roadLosses
                roadTies
                streak
                differential

                teamGameCount
                totalPoints
                totalGoals
                goalsAgainst
                goalsPerGame
                goalsAgainstPerGame
              }
              baseball {
                id
                seasonWins
                seasonLosses
                seasonTies
                seasonPercentWins
                districtWins
                districtLosses
                districtTies
                districtPercentWins
                homeWins
                homeLosses
                homeTies
                roadWins
                roadLosses
                roadTies
                streak
                differential

                teamGameCount
              }
            }
          }`;

    try {
      // update season team
      const response = await this.client.mutate({ mutation: MUTATION });

      // update individual players
      const playerPromises =
        modifiedPlayerData &&
        modifiedPlayerData.map(async (player) => {
          const playerResponse = await unionDataProvider.update(
            "players",
            player
          );
          return _.get(playerResponse, "data");
        });
      const playersResponse = await Promise.all(playerPromises);

      // merge season team and player responses into 1 object
      const playerIds = playersResponse.map((item) => item.id);
      const transformedPlayers = _.get(
        response,
        "data.UpdateSeasonTeam.players",
        []
      ).map((player) => {
        if (!playerIds.includes(player.id)) return player;
        return playersResponse.find((p) => p.id === player.id);
      });
      const data = {
        ..._.get(response, "data.UpdateSeasonTeam"),
        players: transformedPlayers
      };

      return { data };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async create(resource, params) {
    console.log(
      "SeasonTeamsDataProvider.create(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    objectInfo.team = objectInfo.team_id;
    delete objectInfo.team_id;
    delete objectInfo.sportCode;
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const CREATE_OBJECT = gql`
          mutation {
            CreateSeasonTeam(${objectString}) {
              id
              seasonCode
              sportCode
              isInArea 
              rollupMode
              coachEmail
              coachName
              coachUpdated
              team {
                id
              }
              district {
                id
              }
            }
          }`;
    const response = await this.client.mutate({ mutation: CREATE_OBJECT });
    return { data: response.data.CreateSeasonTeam };
  }

  async delete(resource, params) {
    console.log(
      "SeasonTeamsDataProvider.delete(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    let infoString = JSON.stringify({ id: params.id }).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    infoString = infoString.substring(1, infoString.length - 1).trim();
    const DESTROY_OBJECT = gql`
            mutation {
              DeleteSeasonTeamByID(${infoString})
            }`;
    const response = await this.client.mutate({ mutation: DESTROY_OBJECT });
    if (!response) throw new Error("BAD:", JSON.stringify(response));
    return { data: params.previousData };
  }
}

export default SeasonTeamsDataProvider;
